import React, { useState } from 'react';
import LegalModal from './LegalModal';
import { privacyPolicyContent, termsContent } from './legalText';

const Footer = () => {
  const [activeModal, setActiveModal] = useState(null); // 'privacy' | 'terms' | null

  return (
    <footer className="footer-section" style={{ backgroundColor: '#080b0f' }}>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="navbar-logo mb-4">
              <img src="/css/buzzminded logo 3.jpg.jpeg" alt="BuzzMinded Logo" style={{ height: '70px', objectFit: 'contain', mixBlendMode: 'screen', filter: 'contrast(1.5) brightness(0.8)' }} />
            </div>
            <p className="footer-desc">
              Your partner in digital growth. We build experiences that scale and convert.
            </p>
            <div className="social-links">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Services</h4>
            <ul>
              <li><a href="#services">SEO Optimization</a></li>
              <li><a href="#services">PPC Ads</a></li>
              <li><a href="#services">Social Media</a></li>
              <li><a href="#services">Web Development</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Company</h4>
            <ul>
              <li><a href="#difference">About Us</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#cta">Contact</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Legal</h4>
            <ul>
              <li>
                <a href="#privacy" onClick={(e) => { e.preventDefault(); setActiveModal('privacy'); }} style={{ cursor: 'pointer' }}>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms" onClick={(e) => { e.preventDefault(); setActiveModal('terms'); }} style={{ cursor: 'pointer' }}>
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Partner Banner in Footer */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 0', borderTop: '1px solid var(--border-color)', marginTop: '20px' }}>
          <span style={{ color: 'var(--text-muted)', fontSize: '13px', letterSpacing: '1.5px', textTransform: 'uppercase', fontWeight: '600', marginBottom: '16px' }}>A Proud Partner Of</span>
          <a href="https://karmelinfotech.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <img
              src="/images/image.png"
              alt="Karmel Infotech"
              style={{
                height: '120px',
                objectFit: 'contain',
                // filter: 'brightness(0) invert(1)',
                // opacity: '0.6', 
                transition: 'opacity 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.6'}
            />
          </a>
        </div>

        <div className="footer-bottom" style={{ paddingTop: '20px' }}>
          <p>&copy; {new Date().getFullYear()} BuzzMinded. All rights reserved.</p>
        </div>
      </div>

      {/* Render the Legal Modals */}
      <LegalModal
        isOpen={activeModal !== null}
        onClose={() => setActiveModal(null)}
        title={activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
        content={activeModal === 'privacy' ? privacyPolicyContent : termsContent}
      />
    </footer>
  );
};

export default Footer;
